// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2Cjdx","unreadBadge":"styles_unreadBadge__1WTWN","modalContent":"styles_modalContent__2D729","modal":"styles_modal__3L0ih"};